var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-checkbox-group"},[_c('checkbox-group',{ref:"editor",attrs:{"options":_vm.checkboxGroupOptions,"dataId":_vm.dataId,"validateArg":_vm.validateArg},on:{"change":_vm.changeHandle}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }